import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.meine-incidents-veranstaltung';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsMeineIncidentsVeranstaltungEffects {

    MeineIncidentsVeranstaltung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MEINE_INCIDENTS_VERANSTALTUNG),
        mergeMap((x: ac.GetMeineIncidentsVeranstaltungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMeineIncidentsVeranstaltung(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetMeineIncidentsVeranstaltungErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMeineIncidentsVeranstaltungFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
